import { MBQuestionInputActionButton } from '@shared/components/blocks/lib/inputQuestion/actionButton';

interface Props {
  label: string;
  onPress: () => void;
  uploading: boolean;
}

export function MBQuestionFile({ label, onPress, uploading }: Props) {
  return (
    <MBQuestionInputActionButton
      label={label}
      onPress={onPress}
      icon="paperclip"
      disabled={uploading}
      loading={uploading}
    />
  );
}
